import styled from 'styled-components';

const HeaderHolder = styled.div`
	grid-area: header;
	width: 100%;
    z-index: 14;
    margin: 0 auto;
	top: 0;
   .header {
	   	position: relative;
		display: grid;
		grid-template-columns: 20% 60% 20%;
		grid-template-rows: 1fr;
		grid-gap: 0;
		grid-template-areas: 
		'brand nav multi';
		height: 90px;
		max-height: 90px;
	   	background-color: #20272d;
	   	border-bottom: 2px solid rgba(25,25,25,.2);
	  	color: white;
	  	align-items: baseline;
	  	font-weight: 700;
		font-family: "Quicksand", sans-serif;

		@media only screen and (max-width: 920px) {
			grid-template-columns: 50% 0% 50%;
		}
		   
	   img {
		height: 25px;
		max-width: 40px;
	   }

	   &__brand-nav {
			position: absolute;
			top: 20px;
			display: grid;
			grid-area: brand;
			grid-template-columns: 20% 80%;
			grid-template-rows: 1fr;
			grid-template-areas: 'hamb logo';

			span {
				position: absolute;
				left: 138px;
				top: 34px;
				font-size: 12px;
				color: #726b55;
				opacity: 0;
				transition: opacity 1s ease;
				z-index:12;
				text-transform: uppercase;

				&.inverted {
					opacity: 1;
					transition: opacity 1s ease;
					&.ham-home {
						display:none;
					}
				}
			}

			&__hamb-menu {
				cursor: pointer;
				font-size: 25px;
				color: white;
				grid-area: hamb;
				height: 100%;
				padding-left: 30px;
				z-index:12;
				transition: color 0.26s ease;
				width: 55px;
				margin-top: 16px;
				outline: none;

				&.inverted {
					color: #20272d;
					transition: color 0.26s ease;
				}

				@media only screen and (max-width: 920px) {
					text-align: center;
					min-width: 30px;
					padding-left: 0;
				}

			}

			&__logo {
			grid-area: logo;
			height: auto;
			align-self: center;
			margin-left:35px;
			z-index:12;
			transition: filter 0.26s ease;

				@media only screen and (max-width: 920px) {
					margin-left:15px;
					min-width: auto;
				}

				&.inverted {
					filter:invert(1);
					transition: filter 0.26s ease;
				}
			
				img {
					display: flex;
					justify-content: left;
					align-items: left;
					min-width: 150px;
					max-width: 180px;
					height: 62px;
					@media only screen and (max-width: 320px) {
						max-width: 150px;
					}
				}
			}
	   }

	   &__main-nav {
		grid-area: nav;
		display: inline-flex;
		place-content: center;
		margin-top:35px;

		@media only screen and (max-width: 1050px) {
			display: none;
		}

			.r-separator {
				width: 20px;
				border-right: 1px solid gray;
				height: 30px;
			}

			a {
				position: relative;
				cursor: pointer;
				margin-left:20px;
				display: flex;
				justify-content: center;
				align-items: center;
				text-decoration: none;
				color: white !important;
				font-size: 18px;
				text-transform:uppercase;
				white-space: nowrap;

				&:active, &:focus, &:visited, &:focus {
					color: #d2d9df;
				}

				&:hover {
					color: #d2d9df !important;
				}

				&:hover:before {
					content: "";
					width: 100%;
					height: 11px;
					position: absolute;
					bottom: -24px;
					left: 2%;
					background: transparent url(/static-assets/theme/svg/hover-decoration.svg) center bottom no-repeat;
					background-size: 50px;
					overflow: visible;
					cursor: pointer;
					background-position: top;
				}
				img {
					filter: invert(73%) sepia(23%) saturate(202%) hue-rotate(166deg) brightness(86%) contrast(93%);
					padding-right: 5px;
				}
			}
			span {
				cursor: pointer;
				padding-left:25px;
			}

			.live-counter {
				position: relative;
				border: 1px solid red;
				color: white;
				border-radius: 16px;
				text-align: center;
				font-size: 18px;
				line-height: 20px;
				padding-right: 32px;
				outline: none;
		
				&:before {
					bottom: -25px !important;
				}

				&__ico {
					position: absolute;
					background-color: #cc0000;
					border-radius: 2em;
					width: 27px;
					line-height: 28px;
					right: 0px;
					transition: all 0.4s ease-in;
					animation: pulse-opacity 3s infinite;
					pointer-events: none;
				}
			}
	   }

	   &__multi {
			grid-area: multi;
			display: grid;
			position: absolute;
			top: 0px;
			right: 0px;
			grid-gap: 0px;
			grid-row-gap: 12px;

			&__social {
				height: auto;
				grid-column-start: 1;
				grid-column-end: 1;
				grid-row-start: 2;
				grid-row-end: 2;

				@media only screen and (max-width:1050px) {
					display: none;
				}
				a {
					filter: invert(99%) sepia(2%) saturate(4859%) hue-rotate(326deg) brightness(71%) contrast(70%);
					width: auto;
					&:hover{
						filter: invert(93%) sepia(12%) saturate(118%) hue-rotate(166deg) brightness(91%) contrast(94%);
					}
					img {
						max-height: 28px;
						max-width: 28px;
						margin-right: 10px;
						margin-top: 2px;
						padding: 4px;
					}
				}
			}

			&__language-p {
				color: white;
				cursor: pointer;
				height: 100%;
				text-align: center;
				grid-column-start: 2;
				grid-column-end: 3;
				grid-row-start: 1;
				grid-row-end: 1;
				background-color: #726b55;
				width: 90px;
				font-weight: 300;
				padding-top: 5px;
				padding-bottom: 5px;
				border-left: 1px solid #6b6b6b;
				border-bottom: 1px solid #6b6b6b;
				border-radius: 0 0 0 5px;
				justify-self: self-end;
				font-weight: 400;
				font-size: 14px;

				&:hover {
					color: white;
					background-color: #5f7586;
				}
			}
			
			&__search {
				cursor: pointer;
				text-align: right;
				height: 100%;
				font-size: 25px;
				grid-column-start: 2;
				grid-column-end: 2;
				grid-row-start: 2;
				grid-row-end: 2;
				border-left: 1px solid #5f7586;
				outline: none;
								
				svg {
				    margin-left: 6px;
    				margin-right: 6px;
					padding: 4px;
					width: 25px;
					outline: none;
					path {
						fill: #97a7b5;
					}
					&:hover {
						path {
							fill: #d2d9df;
						}
					}
				}		
			}
	   }

   }
`;

export default HeaderHolder;